import React, { Component } from 'react';
//import { connectHits } from 'react-instantsearch/dom';
import OrderCard from '../../dashBoard/newDashboard/OrderCard'
import OrderCardSmall from '../../dashBoard/newDashboard/OrderCardSmall'
import { Grid, } from 'semantic-ui-react'



class CustomHits extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    componentDidMount() {
        console.log("mini1 - ivan:"+this.props.ivan)
        //console.log("csxt1:mainCardObjects" + this.props.mainCardObjects.length);
    }

    
    
    render() {
        const hitsUI = this.props.ivan
        ? this.props.hits.map(hit =>
            <Grid.Column>
                <OrderCardSmall
                    //user={this.state.userFromFirebaseNode}
                    searchNow={true}
                    user={this.props.user}
                    order={hit}
                    orderStatuses={this.props.orderStatuses}
                    designers={this.props.designers}
                    mainCardObjects={this.props.mainCardObjects}
                    setRefreshToFalse={this.props.setRefreshToFalse}
                    setRefreshToTrue={this.props.setRefreshToTrue} 
                    refresh={this.props.refresh}
                    awaitingRefresh={this.props.awaitingRefresh}
                    //isAdmin={this.props.isAdmin} 
                    algoliaUser = {this.props.algoliaUser}
                    salesPeopleChoices = {this.props.salesPeopleChoices}
                    deliveryPersonChoices = {this.props.deliveryPersonChoices}
                    
                    />

            </Grid.Column>)
        : this.props.hits.map(hit =>
            <Grid.Column>
                <OrderCard
                    //user={this.state.userFromFirebaseNode}
                    searchNow={true}
                    user={this.props.user}
                    order={hit}
                    orderStatuses={this.props.orderStatuses}
                    designers={this.props.designers}
                    mainCardObjects={this.props.mainCardObjects}
                    setRefreshToFalse={this.props.setRefreshToFalse}
                    setRefreshToTrue={this.props.setRefreshToTrue} 
                    refresh={this.props.refresh}
                    awaitingRefresh={this.props.awaitingRefresh}
                    //isAdmin={this.props.isAdmin} 
                    algoliaUser = {this.props.algoliaUser}
                    salesPeopleChoices = {this.props.salesPeopleChoices}
                    deliveryPersonChoices = {this.props.deliveryPersonChoices}
                    
                    />

            </Grid.Column>
        )

        return <div style={{ marginTop: '10px' }}>
            <h1>{this.props.ivan}</h1>
            <Grid stackable columns={4}>
                {hitsUI}
            </Grid>


        </div>
    }
}

//const ConnectedCustomHit = connectHits(CustomHits);
//export default connectHits(CustomHits);
export default CustomHits;

//export const chits = connectHits(CustomHits);


// WEBPACK FOOTER //
// ./src/components/newSite/algolia/CustomHits.js